import { ScrollView, useDripsyTheme, View } from 'dripsy';
import Animated from 'react-native-reanimated';

import { UniTabHeader } from '@/design-system/components/tabs';
import { Platform } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useStore } from 'store/store';

interface UniNativeModalProps {
  animatedStyle: Animated.AnimateStyle<{}>;
  onBack: () => void;
  title?: string;
  showBackButton?: boolean;
  showHeader?: boolean;
  backgroundColor?: string;
  hasScroll?: boolean;
}

export const NativeModalView: React.FC<UniNativeModalProps> = ({
  title,
  showBackButton,
  showHeader = true,
  backgroundColor,
  hasScroll = true,
  animatedStyle,
  onBack,
  children
}) => {
  const theme = useDripsyTheme();
  const store = useStore();
  const insets = useSafeAreaInsets();
  const isWeb = Platform.OS === 'web';
  const defaultBackground = store.theme === 'dark' ? '#1A1A1A' : '#FFFFFF';

  return (
    <Animated.View
      style={[
        {
          position: 'absolute',
          top: 0,
          height: '100%',
          width: '100%',
          backgroundColor: backgroundColor || theme.colors?.$backgroundPrimary || defaultBackground
        },
        animatedStyle
      ]}>
      {hasScroll ? (
        <ScrollView sx={{ flex: 1, pt: !isWeb ? insets.top : 0 }} contentContainerSx={{ height: '100%', flex: 1 }}>
          {showHeader && <UniTabHeader title={title || ''} onBack={onBack} showBackButton={showBackButton} />}
          {children}
        </ScrollView>
      ) : (
        <View sx={{ flex: 1, pt: !isWeb ? insets.top : 0, height: '100%' }}>
          {showHeader && <UniTabHeader title={title || ''} onBack={onBack} showBackButton={showBackButton} />}
          {children}
        </View>
      )}
    </Animated.View>
  );
};
